import { Reveal, SectionHeading } from "./Reveal";
import { Phone, UtensilsCrossed } from "lucide-react";

export const Dining = ({ restaurants = [] }) => (
  <section id="dining" className="bg-[#EFEBE1] py-20 md:py-28" data-testid="dining-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="mb-14">
        <SectionHeading eyebrow="Eat Like a Local" title="Best Places to Eat Nearby" testId="dining" />
      </div>
      <div className="grid sm:grid-cols-2 gap-6">
        {restaurants.map((r, i) => (
          <Reveal key={r.id || r.name} delay={i * 0.07}>
            <div
              className="group bg-[#FAF8F5] border border-[#0D1B2A]/10 rounded-2xl p-6 sm:p-7 hover:shadow-xl hover:border-[#C5A059]/40 transition-all duration-300 flex gap-5"
              data-testid={`restaurant-card-${r.id || i}`}
            >
              <div className="shrink-0 w-12 h-12 rounded-full bg-[#0A192F] text-[#C5A059] flex items-center justify-center">
                <UtensilsCrossed size={20} />
              </div>
              <div className="flex-1">
                <div className="flex items-start justify-between gap-3">
                  <h3 className="font-serif-display text-xl sm:text-2xl font-semibold text-[#0A192F]">{r.name}</h3>
                  <span className="text-[#C5A059] font-semibold text-sm">{r.price}</span>
                </div>
                <p className="text-xs uppercase tracking-[0.2em] text-[#C5A059] font-semibold mt-1">{r.cuisine}</p>
                <p className="text-[#4A5568] text-sm leading-relaxed mt-3">{r.description}</p>
                {r.phone && (
                  <a href={`tel:${r.phone.replace(/[^+\d]/g, "")}`} className="inline-flex items-center gap-2 text-sm font-medium text-[#0A192F] hover:text-[#C5A059] transition-colors mt-3" data-testid={`restaurant-call-${r.id || i}`}>
                    <Phone size={14} /> {r.phone}
                  </a>
                )}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
